<template>
  <div>
    <b-button variant="link" @click="setNextPage(targetPageValue)">{{
      targetPageName
    }}</b-button>
  </div>
</template>

<script>
export default {
  props: ["targetPageValue", "targetPageName"],
  methods: {
    setNextPage(pageName) {
      this.$emit("changePage", pageName);
    },
  },
};
</script>